<div class="container">
    <div class="error-content">
        <h2>{{ call.description }}</h2>
        <h3 class="error">{{ call.errorHandling?.message }}</h3>
    </div>
    <div class="tp-close">
        <button (click)="close()" mat-raised-button color="primary">{{ "Close" | translate }}</button>
    </div>
</div>
